import { css } from '@emotion/react';

import { campaignManagerTheme } from '@campaign-manager/theme';

export const alignLeft = css`
  text-align: left;
`;

export const alignCenter = css`
  text-align: center;
`;

export const alignRight = css`
  text-align: right;
`;

export const weightRegular = css`
  font-weight: 400;
`;

export const weightMedium = css`
  font-weight: 500;
`;

export const weightBold = css`
  font-weight: 700;
`;

export const color = (value: string) => css`
  color: ${value};
`;

export const size = (value: keyof typeof campaignManagerTheme.fontSize) => css`
  font-size: ${campaignManagerTheme.fontSize[value]};
  line-height: ${campaignManagerTheme.lineHeight[value]};
`;

export const whiteSpace = (value: string) => css`
  white-space: ${value};
`;

export const italic = css`
  font-style: italic;
`;
